// extracted by mini-css-extract-plugin
export default {"grayScaleBackground":"Loading_grayScaleBackground__ZELmV","window":"Loading_window__4pNLz","center":"Loading_center__q1tTn","icon":"Loading_icon__auz2L","spin":"Loading_spin__J5ltN"};